import { useEffect, useRef } from 'react';

export function useEventListener<T extends Event = Event>(
  eventName: string,
  handler: (event: T) => void,
  element?: any,
  options?: boolean | AddEventListenerOptions,
) {
  const savedHandler = useRef(handler);

  useEffect(() => {
    savedHandler.current = handler;
  }, [handler]);

  useEffect(() => {
    let targetElement: any = undefined;

    if (element === undefined) {
      targetElement = window;
    } else if (element !== null) {
      targetElement = 'current' in element ? element.current : element;
    }

    if (!targetElement?.addEventListener) return;

    const eventListener: EventListener = (event) =>
      savedHandler.current(event as T);

    targetElement.addEventListener(eventName, eventListener, options);

    return () => {
      targetElement.removeEventListener(eventName, eventListener, options);
    };
  }, [eventName, element, options]);
}
